export function gaTracker(eventName, data) {
  if (typeof window.gtag === 'function') {
    console.log('GA', eventName, data);
    window.gtag('event', eventName, data);
  }
}
